import "yet-another-react-lightbox/dist/styles.css";
import { Maybe } from "../types/types";

export default function getSlides(photos: Maybe<string[]>) {
    return photos?.map(photo => {
        return { src: photo }
    })
}
